/** @format */

import moment, { Moment } from 'moment'
import { getDataType } from './index'
// moment、string、date、时间戳 转 日期格式
export const formatDate = (
  date: Moment | string | Date | number,
  format = 'YYYY-MM-DD HH:mm:ss'
) => {
  if (date) {
    const type = getDataType(date)
    if (type === 'String' || type === 'Date' || type === 'Number') {
      return moment(date).format(format)
    } else {
      return (date as Moment).format(format)
    }
  } else {
    return ''
  }
}

// 时间戳转Moment
export const timestampToMoment = (timestamp: [number, number]): [Moment, Moment] => {
  return timestamp?.map(time => moment(time)) as [Moment, Moment]
}

// 天转秒
export const dayToSecond = (day: number): number => day * 24 * 60 * 60

// 时转秒
export const hoursToSecond = (hours: number): number => hours * 60 * 60
